<template>
  <div>
    <div class="rounded-t-md bg-green-darkest text-white font-semibold">
      <div class="px-4 py-3 flex items-center">
        <button v-on:click="open = !open"
                type="button"
                class="lg:hidden focus:outline-none mr-2 lg:mr-0"
                aria-label="Toggle Category Menu">
          <i data-feather="filter"
             class="w-4 h-4"
          ></i>
        </button>
        <h2>{{ this.categorySidebarTitle }}</h2>
      </div>
    </div>
    <div id="category-sidebar-widget-content" class="rounded-b-md bg-green-darkest-tint-25 text-grey font-semibold lg:block"
         v-bind:class="[open ? 'block' : 'hidden']">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategorySidebar",
  props: {
    currentCategoryTermUrl: {
      type: String,
      required: true
    },
    categorySidebarTitle: {
      type: String,
      default: 'Categories',
      required: false
    },
  },
  data() {
    return {
      open: false
    }
  },
  mounted() {
    /* For current category page (as passed via props) change element styling */
    let currentCategoryListItems = document.querySelectorAll(
        "#category-sidebar-widget-content a[href='" + this.currentCategoryTermUrl + "']"
    );

    if (typeof currentCategoryListItems === 'undefined' || currentCategoryListItems.length === 0) {
      return;
    }

    currentCategoryListItems.forEach(function(element) {
      element.classList.add('text-blue', 'pointer-events-none', 'cursor-default');
    });
  }
}
</script>

<style scoped>

</style>